import { useEffect, useMemo, useState } from "react";
import { debounce } from "lodash";

export const useDebouncedSearch = (
  searchTerm: string,
  debounceTime: number = 1000,
) => {
  const [debouncedValue, setDebouncedValue] = useState(searchTerm);

  const debouncedCallback = useMemo(() => {
    return debounce(async (searchTerm) => {
      setDebouncedValue(searchTerm.replace(/ {2,}/g, " ").trim());
    }, debounceTime);
  }, [setDebouncedValue]);

  useEffect(() => {
    debouncedCallback(searchTerm);
    return () => {
      debouncedCallback.cancel();
    };
  }, [setDebouncedValue, searchTerm]);

  return debouncedValue;
};
